export const radii = {
  spot: {
    variant1: '46% 54% 53% 47% / 43% 62% 38% 57%',
    variant2: '46% 54% 46% 54% / 55% 47% 53% 45%',
  },
};
